export default __webpack_public_path__ + "static/media/icon_add-to-group.1cbbcdd1.svg";